

import React, { useState, useEffect } from "react";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import TenderSettlementHelp from "../../../Helper/TenderSettlementHelp";
import { Grid, Box, Typography, Button, Paper, Stack } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import PageNotFound from '../../../Common/PageNotFound/PageNotFound'

const API_URL = process.env.REACT_APP_API;

function SettleTenders() {
  const [tenderNo, setTenderNo] = useState("");
  const [tenderData, setTenderData] = useState(null);
  const [paymentTo, setPaymentTo] = useState("");
  const [accoid, setAccoid] = useState("");
  const [paymentToName, setPaymenToName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [canView, setCanView] = useState(null);
  const uid = sessionStorage.getItem("uid");
  const companyCode = sessionStorage.getItem("Company_Code");

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        const userCheckUrl = `${API_URL}/get_user_permissions?Company_Code=${companyCode}&Program_Name=/Settletenders&uid=${uid}`;
        const response = await axios.get(userCheckUrl);
        const permission = response.data?.UserDetails?.canView;
        setCanView(permission === "Y");
      } catch (error) {
        console.error("Permission check failed:", error);
        setCanView(false);
      }
    };

    checkPermissions();
  }, []);


  const handleMill_Code = (selectedTenderNo) => {
    setTenderNo(selectedTenderNo);
  };

  const handleTenderData = (detailsObj) => {
    setTenderData(detailsObj);
  };

  console.log(tenderData)

  const handlePayment_To = (
    acctCode,
    accoid,
    name,
    mobileNo,
    gstNo,
    TdsApplicable
  ) => {
    setPaymentTo(acctCode);
    setAccoid(accoid);
    setPaymenToName(name);
  };


  const handleSettleTender = async () => {
    setIsLoading(true);
    try {
      if (!tenderData) {
        Swal.fire({
          title: "Error!",
          text: "No tender selected.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }

      if (!paymentTo) {
        Swal.fire({
          title: "Error!",
          text: "Please select a Payment To account.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }


      const sanitizedDetails = tenderData.last_tender_details_data.map(
        (item) => ({
          Tender_No: item.Tender_No,
          Company_Code: item.Company_Code,
          Buyer: item.Buyer,
          Buyer_Quantal: item.Buyer_Quantal,
          Sale_Rate: item.Sale_Rate,
          Commission_Rate: item.Commission_Rate,
          Sauda_Date: item.Sauda_Date,
          Lifting_Date: item.Lifting_Date,
          Narration: item.Narration,
          ID: item.ID,
          Buyer_Party: item.Buyer_Party,
          AutoID: item.AutoID,
          IsActive: item.IsActive,
          year_code: item.year_code,
          Branch_Id: item.Branch_Id,
          Delivery_Type: item.Delivery_Type,
          tenderid: item.tenderid,
          tenderdetailid: item.tenderdetailid,
          buyerid: item.buyerid,
          buyerpartyid: item.buyerpartyid,
          sub_broker: item.sub_broker,
          sbr: item.sbr,
          tcs_rate: item.tcs_rate,
          gst_rate: item.gst_rate,
          tcs_amt: item.tcs_amt,
          gst_amt: item.gst_amt,
          ShipTo: item.ShipTo,
          CashDiff: item.CashDiff,
          shiptoid: item.shiptoid,
          dispatched: item.despatched,
          balance: item.balance,
        })
      );

      const headWithPayment = {
        ...tenderData.last_tender_head_data,
        Payment_To: paymentTo,
        pt: accoid,
      };

      const payload = {
        last_tender_head_data: headWithPayment,
        last_tender_details_data: sanitizedDetails,
      };

      const response = await axios.post(
        `${API_URL}/tender_settlement`,
        payload
      );

      Swal.fire({
        title: "Success!",
        text: "Tender settled and new record created.",
        icon: "success",
        confirmButtonText: "OK",
      });

      setIsLoading(false);
      setTenderNo("");
      setTenderData(null);
      setPaymentTo("");
    } catch (error) {
      setIsLoading(false);
      console.error("Error settling tender:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to settle tender.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  if (canView === false) return <PageNotFound />;

  return (
    canView === false ? <PageNotFound /> : (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        minHeight="70vh"
      >
        <Paper
          elevation={6}
          style={{
            padding: '32px',
            width: 'fit-content',
            maxWidth: '95%',
            overflow: 'hidden',
            borderRadius: '16px',
            background: '#fdfdfd',
            boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            transition: 'all 0.4s ease-in-out',
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            align="center"
            style={{
              color: '#1976d2',
              fontWeight: 'bold',
              marginBottom: '24px',
              transition: 'color 0.3s ease',
            }}
          >
            🎯 Settle Tenders
          </Typography>

          <Stack spacing={3} mt={3} style={{ width: '100%' }}>

            <div className="SugarSaleBill-row" style={{ marginTop: "10px" }}>
              <label htmlFor="Bill_From" className="SugarSaleBillLabel" >
                Tender No :
              </label>
              <div >
                <div style={{ marginLeft: "16px" }}>
                  <TenderSettlementHelp
                    name="Tender_No"
                    onAcCodeClick={handleMill_Code}
                    tenderNo={tenderNo}
                    paymentTo_Name={tenderData?.last_tender_details_data?.[0]?.PaymentToAcName}
                    onTenderSelect={handleTenderData}
                  />
                </div>
              </div>
            </div>

            <div className="SugarSaleBill-row" style={{ marginTop: "10px" }}>
              <label htmlFor="Bill_From" className="SugarSaleBillLabel" >
                Payment To :
              </label>
              <div >
                <div >
                  <AccountMasterHelp
                    name="Payment_To"
                    onAcCodeClick={handlePayment_To}
                    CategoryName={paymentToName}
                    CategoryCode={paymentTo}
                    Ac_type={[]}
                  />
                </div>
              </div>
            </div>

          </Stack>

          <Box mt={4} display="flex" justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSettleTender}
              disabled={!tenderData || !paymentTo || isLoading}
              style={{
                padding: '10px 32px',
                fontWeight: 600,
                fontSize: '1rem',
                backgroundColor: '#1976d2',
                transition: 'all 0.3s ease',
                transform: isLoading ? 'scale(0.95)' : 'scale(1)',
                opacity: !tenderData || !paymentTo ? 0.7 : 1,
              }}
              onMouseEnter={(e) => {
                if (!isLoading) e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              {isLoading ? "Settling..." : "✅ Settle Tender"}
            </Button>
          </Box>
        </Paper>

        {isLoading && (
          <Box
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              height: '100vh',
              width: '100vw',
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              animation: 'fadeInScale 0.3s ease-in-out',
            }}
          >
            <div style={{ transform: 'scale(1)', transition: 'transform 0.3s ease' }}>
              <SaveUpdateSpinner />
            </div>
          </Box>
        )}
      </Box>
    )
  );
}

export default SettleTenders;
